/* eslint-disable sort-keys-fix/sort-keys-fix */
import aamagazine from "../styling/aamaganize"
import adiraParty from "../styling/adiraparty"
import antisthlm from "../styling/antisthlm"
import asense from "../styling/asense"
import assila from "../styling/assila"
import aurora from "../styling/aurora"
import BLVSH from "../styling/BLVSH"
import barutopia from "../styling/barutopia"
import base from "../styling/base"
import berlinerParty from "../styling/berlinerparty"
import blockula from "../styling/blockula"
import bmearch from "../styling/bmearch"
import borderlessCreatures from "../styling/borderlesscreatures"
import botaniskaBaren from "../styling/botaniskabaren"
import bqa from "../styling/bqa"
import brenn from "../styling/brenn"
import bricklane from "../styling/bricklane"
import cageByUndr from "../styling/cagebyundr"
import cctv from "../styling/cctv"
import clubCommission from "../styling/clubcommission"
import clubM from "../styling/clubm"
import cocktaildamore from "../styling/cocktaildamore"
import countercult from "../styling/countercult"
import cuddles from "../styling/cuddles"
import curaberlin from "../styling/curaberlin"
import DEBASER from "../styling/DEBASER"
import damntechno from "../styling/damntechno"
import damur from "../styling/damur"
import dastechnoteam from "../styling/dastechnoteam"
import daswerk from "../styling/daswerk"
import demo from "../styling/demo"
import department from "../styling/department"
import discoParadise from "../styling/discoparadise"
import discoplanet from "../styling/discoplanet"
import dissonans from "../styling/dissonans"
import djalban from "../styling/djalban"
import doof from "../styling/doof"
import dudj from "../styling/dudj"
import dynamicberlin from "../styling/dynamicberlin"
import EDGE from "../styling/EDGE"
import echobox from "../styling/echobox"
import ekko from "../styling/ekko"
import elysion from "../styling/elysion"
import enigma from "../styling/enigma"
import expeditions from "../styling/expeditions"
import FLATMATES from "../styling/FLATMATES"
import faggotry from "../styling/faggotry"
import feverdream from "../styling/feverdream"
import fleamarket from "../styling/fleamarket"
import fourPlay from "../styling/fourplay"
import gegen from "../styling/gegen"
import ginene from "../styling/ginene"
import gladaskojar from "../styling/gladaskojar"
import hoq from "../styling/HOQ"
import heatByUndr from "../styling/heatbyundr"
import hera from "../styling/hera"
import hetcomite from "../styling/hetcomite"
import hights from "../styling/hights"
import homeAgain from "../styling/homeagain"
import hybrida from "../styling/hybrida"
import iheartberlin from "../styling/iheartberlin"
import ikigai from "../styling/ikigai"
import indexfm from "../styling/indexfm"
import insomniaClubBerlin from "../styling/insomniaclubberlin"
import kbk from "../styling/kbk"
import kindpeople from "../styling/kindpeople"
import kinkyBeachFestivalBerlin from "../styling/kinkybeachfestivalberlin"
import kitkatclub from "../styling/kitkatclub"
import koichaCollective from "../styling/koichacollective"
import kollektivet from "../styling/kollektivet"
import kollektivlivmoder from "../styling/kollektivlivmoder"
import kuneJuly25 from "../styling/kuneJuly25"
import kurashi from "../styling/kurashi"
import latinFusion from "../styling/latinfusion"
import londonlive from "../styling/londonlive"
import losgehtsberlin from "../styling/losgehtsberlin"
import magmix from "../styling/magmix"
import mehfil from "../styling/mehfil"
import missDreamz from "../styling/missdreamz"
import muumimaa from "../styling/muumimaa"
import nattoga from "../styling/nattoga"
import noisey from "../styling/noisey"
import nomosocialclub from "../styling/nomosocialclub"
import oskaddV2 from "../styling/oskaddV2"
import ostersjopirat from "../styling/ostersjopirat"
import overload from "../styling/overload"
import oxytocin from "../styling/oxytocin"
import patricia from "../styling/patricia"
import pornceptual from "../styling/pornceptual"
import prezidentAdvisor from "../styling/prezidentadv"
import proscenium from "../styling/proscenium"
import pruyrvu from "../styling/pruyrvu"
import pulzar from "../styling/pulzar"
import qs1 from "../styling/qs1"
import radiobrus from "../styling/radiobrus"
import radioradio from "../styling/radioradio"
import resebyran from "../styling/resebyran"
import rosendalgardenparty from "../styling/rosendalgardenparty"
import Slutstation from "../styling/Slutstation"
import SACHSENTRANC from "../styling/sachsentrance"
import sacranatura from "../styling/sacranatura"
import sahhara from "../styling/sahhara"
import sahraparty from "../styling/sahraparty"
import saman from "../styling/saman"
import sapphicspace from "../styling/sapphicspace"
import saveoursound from "../styling/saveoursound"
import section8 from "../styling/section8"
import serpent from "../styling/serpent"
import shelter from "../styling/shelter"
import sisterwood from "../styling/sisterwood"
import sixFemnoll from "../styling/sixFemnoll"
import skogsrejv from "../styling/skogsrejv"
import sneakfreaxx from "../styling/sneakfreaxx"
import staub from "../styling/staub"
import sthlmfw from "../styling/sthlmfw"
import sthlmpride from "../styling/sthlmpride"
import studiobarnhus from "../styling/studiobarnhus"
import studiosven from "../styling/studiosven"
import substation from "../styling/substation"
import subverted from "../styling/subverted"
import tck from "../styling/tck"
import theClub from "../styling/theclub"
import tillsammans from "../styling/tillsammans"
import tis from "../styling/tis"
import tracey from "../styling/tracey"
import trax from "../styling/trax"
import trillah from "../styling/trillah"
import tumultkultur from "../styling/tumultkultur"
import { COMMUNITY_PAGES_PATH_PREFIX } from "../styling/types"
import UNDERBRON from "../styling/UNDERBRON"
import undr from "../styling/undr"
import unleashedByUndr from "../styling/unleashedbyundr"
import vrau from "../styling/vrau"
import wbase from "../styling/wbase"
import wholefestival from "../styling/wholefestival"
import xoxa from "../styling/xoxa"
import yereyere from "../styling/yereyere"

export const baseLinktreeStyles = base.styles.linktree

const automatedTesting = {
  ...base,
  code: "automated-testing",
  inviteCode: "automated-testing",
  name: "Automated Testing",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/automated-testing`,
}

export const COMMUNITIES = {
  kune: kuneJuly25,
  hetcomite,
  "demo-1": demo,
  trillah,
  "blo-137": blockula,
  "cct-181": cctv,
  "her-155": hera,
  "tis-101": tis,
  "noi-133": noisey,
  "dis-161": discoplanet,
  "osk-225": oskaddV2,
  "iki-113": ikigai,
  "kol-405": kollektivet,
  "sko-210": skogsrejv,
  "sac-163": sacranatura,
  "sis-151": sisterwood,
  "dja-139": djalban,
  radioradio,
  saveoursound,
  // tradgarden,
  kbk,
  shelter,
  echobox,
  yereyere,
  kurashi,
  aamagazine,
  feverdream,
  base,
  damntechno,
  kindpeople,
  studiosven,
  "bru-213": radiobrus,
  brus: { ...radiobrus, url: `${COMMUNITY_PAGES_PATH_PREFIX}/brus` },
  nattoga,
  "fag-165": faggotry,
  "tum-234": tumultkultur,
  "hyb-312": hybrida,
  "liv-777": kollektivlivmoder,
  bljf: bricklane,
  sthlmfw: sthlmfw,
  rosendal: rosendalgardenparty,
  tck,
  "dep-023": department,
  "ant-080": antisthlm,
  sthlmpride,
  "6femnoll": sixFemnoll,
  "gla-332": gladaskojar,
  "sam-046": saman,
  saman: saman,
  "ekk-018": ekko,
  debaserklubben: DEBASER,
  hoq: hoq,
  "fla-046": FLATMATES,
  underbron: UNDERBRON,
  tradgarden: UNDERBRON,
  "ser-023": serpent,
  "res-080": resebyran,
  "uto-358": barutopia,
  // berlin
  "edg-030": EDGE,
  "dyn-033": dynamicberlin,
  "bme-030": bmearch,
  "bcr-030": borderlessCreatures,
  "bre-656": brenn,
  "dwe-030": daswerk,
  "gin-030": ginene,
  "pro-018": proscenium,
  "cco-030": clubCommission,
  "pra-742": prezidentAdvisor,
  prezidentadv: prezidentAdvisor,
  "ifm-184": indexfm,
  indexfm,
  "mag-001": magmix,
  magmix,
  "sec-008": section8,
  "ihb-477": iheartberlin,
  "stb-080": studiobarnhus,
  "muc-045": muumimaa,
  "slu-022": Slutstation,
  "pat-019": patricia,
  "osp-621": ostersjopirat,
  gegen,
  "sta-423": staub,
  "blv-801": BLVSH,
  "bot-090": botaniskaBaren,
  "pyr-239": pruyrvu,
  "das-991": dastechnoteam,
  "cur-002": curaberlin,
  "sac-808": SACHSENTRANC,
  "ely-101": elysion,
  "eni-030": enigma,
  "doo-018": doof,
  "sub-020": subverted,
  "clu-080": theClub,
  "till-040": tillsammans,
  "clm-046": clubM,
  "sta-030": substation,
  "cda-030": cocktaildamore,
  "dam-030": damur,
  "aur-030": aurora,
  "miss-030": missDreamz,
  "adi-963": adiraParty,
  "por-030": pornceptual,
  "dud-353": dudj,
  "kit-030": kitkatclub,
  "koi-046": koichaCollective,
  "meh-442": mehfil,
  "asb-422": assila,
  "bqa-030": bqa,
  "ber-030": losgehtsberlin,
  "sah-216": sahhara,
  "sah-963": sahraparty,
  "trx-111": trax,
  "ove-304": overload,
  "nom-046": nomosocialclub,
  "sapp-358": sapphicspace,
  "oxy-931": oxytocin,
  "hab-030": homeAgain,
  "qso-001": qs1,
  "lat-030": latinFusion,
  "pul-030": pulzar,
  "ldl-020": londonlive,
  "tra-030": tracey,
  "vra-030": vrau,
  wholefestival: wholefestival,
  "snx-030": sneakfreaxx,
  "dpa-030": discoParadise,
  "fpl-030": fourPlay,
  "exp-030": expeditions,
  "und-030": undr,
  "unl-030": unleashedByUndr,
  "hea-030": heatByUndr,
  "kbf-030": kinkyBeachFestivalBerlin,
  "ins-030": insomniaClubBerlin,
  "cge-030": cageByUndr,
  "bpa-030": berlinerParty,
  "cou-030": countercult,
  "cud-030": cuddles,
  "ase-080": asense,
  "diss-080": dissonans,
  "hgh-080": hights,
  "xox-917": xoxa,
  // standalone pages & testing
  "automated-testing": automatedTesting,
  fleamarket,
  wbase,
}

export const AVAILABLE_COMMUNITIES = Object.values(COMMUNITIES).map((c) => c.code)
